<template>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb" v-if="myBreadcrumb.length">
            <ol class="breadcrumb">
                <li
                    class="breadcrumb-item"
                    v-for="(crumb, key) of myBreadcrumb"
                    :class="{ active: crumb.path == $route.path }"
                    :key="key"
                >
                    <router-link
                        class="breadcrumb-item"
                        :to="linkProp(crumb)"
                        v-if="crumb.path !== $route.path"
                    >{{ getBreadcrumbText(crumb) }}</router-link>
                    <span v-else>{{ getBreadcrumbText(crumb) }}</span>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
import { API } from "@/assets/config";

/**
 * 麵包屑元件
 * Date: 2019/03/23
 */
export default {
    name: "breadcrumb",
    data() {
        return {
            planName: null
        };
    },
    computed: {
        myBreadcrumb() {
            let crumbs = [];
            let matched = this.getMatchedRoutes(this.$route.matched);
            matched.map(route => {
                let hasBreadcrumb = route.meta && route.meta.breadcrumb;
                // 如果是代辦互助基金相關頁面，也要包含 changeBreadcrumb 的路由
                let hasChangeBreadcrumb = route.meta && route.meta.changeBreadcrumb;
                if (hasBreadcrumb || hasChangeBreadcrumb) {
                    crumbs.push(route);
                }
            });

            // 借據管理子頁面 是透過 query 區分，額外加上麵包屑 (頁面：首頁>放款作業>借據管理>執行中)
            const typeMap = {
                getRunningIou: "執行中",
                getBreakIou: "已違約",
                getFinishIou: "已結清",
                getCancelIou: "已失效"
            };

            // 如果有 type，則加入對應的麵包屑
            if (this.$route.query.type && typeMap[this.$route.query.type]) {
                crumbs.push({
                    path: this.$route.path,
                    meta: { breadcrumb: typeMap[this.$route.query.type] }
                });
            }

            return crumbs;
        }
    },
    watch: {
        '$route': {
            handler() {
                this.loadPlanName();
            },
            immediate: true
        }
    },
    methods: {
        getMatchedRoutes(route) {
            return route;
        },
        linkProp(crumb) {
            if (crumb.name || (crumb.handler && crumb.handler.name)) {
                return {
                    name: crumb.name || crumb.handler.name,
                    params: this.$route.params
                };
            }
            return {
                path:
                    crumb.handler && crumb.handler.fullPath
                        ? crumb.handler.fullPath
                        : crumb.path,
                params: this.$route.params
            };
        },
        getBreadcrumbText(crumb) {
            // 如果是代辦互助基金相關頁面，使用動態獲取的方案名稱
            if (this.isAgencyPage() && this.planName) {
                // 只在 agency_edit 或 agent_edit 路由上顯示方案名稱
                if (crumb.name === 'agency_edit' || crumb.name === 'agent_edit') {
                    return this.planName;
                }
            }
            return crumb.meta.breadcrumb;
        },
        isAgencyPage() {
            return this.$route.name && (this.$route.name.startsWith('agency_') || this.$route.name.startsWith('agent_')) && 
                   this.$route.params.code && this.$route.params.code !== 'new';
        },
        loadPlanName() {
            if (this.isAgencyPage() && !this.$route.query.name) {
                // 根據路由名稱決定使用哪個 API
                let apiUrl;
                if (this.$route.name.startsWith('agency_')) {
                    apiUrl = `${API.InsPlanMain}?code=${this.$route.params.code}&action=effective`;
                } else if (this.$route.name.startsWith('agent_')) {
                    apiUrl = `${API.coopInsPlan}?code=${this.$route.params.code}&action=effective`;
                }
                
                if (apiUrl) {
                    this.mAxiosGet(apiUrl, (json) => {
                        if (json.resultData && json.resultData.data) {
                            this.planName = json.resultData.data.name;
                        }
                    });
                }
            } else {
                this.planName = null;
            }
        }
    }
};
</script>